import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  // ECOMMERCES(state, gycwarehouse) {
  //   state.cached = gycwarehouse
  // },
}

export const actions = {

  init({ state, dispatch }) {},

  fetchEcommerceOptions(context, query) {
    query = query || ''
    return axios.options(`${serverUrl}/manager/ecommerces/${query}`).then((response) => {
      return response.data
    })
  },
  fetchCustomerTypeOptions(context, query) {
    query = query || ''
    return axios.options(`${serverUrl}/manager/customers/types/${query}`).then((response) => {
      return response.data
    })
  },
  fetchDocumentTypeOptions(context, query) {
    query = query || ''
    return axios.options(`${serverUrl}/manager/documents/types/${query}`).then((response) => {
      return response.data
    })
  },
  fetchVendorOptions(context, query) {
    query = query || ''
    return axios.options(`${serverUrl}/manager/vendors/${query}`).then((response) => {
      return response.data
    })
  },
  fetchPaymentConditionOptions(context, query) {
    query = query || ''
    return axios.options(`${serverUrl}/manager/payments/conditions/${query}`).then((response) => {
      return response.data
    })
  },
  fetchBussinessUnitOptions(context, query) {
    query = query || ''
    return axios.options(`${serverUrl}/manager/bussiness/units/${query}`).then((response) => {
      return response.data
    })
  },

}